.EmptyStateControl659078356__root {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
}

.EmptyStateControl659078356__image > * {
  display: block;
}

.EmptyStateControl659078356__image:not(:last-child) {
  margin-bottom: 24px;
}

.EmptyStateControl659078356__title:not(:last-child) {
  margin-bottom: 12px;
}

.EmptyStateControl659078356__title + .EmptyStateControl659078356__primaryButton,
.EmptyStateControl659078356__title + .EmptyStateControl659078356__secondaryButton {
  margin-top: 12px;
}



.EmptyStateControl659078356__content,
.EmptyStateControl659078356__title {
  text-align: center;
}

.EmptyStateControl659078356__content:not(:last-child) {
  margin-bottom: 24px;
}

.EmptyStateControl659078356__primaryButton:not(:last-child) {
  margin-bottom: 12px;
}

/* st-namespace-reference="../../../../src/controls/EmptyState/EmptyStateControl.st.css" */